/**
 * A CSS length as pixels, resolved by the browser rather than parsed.
 *
 * The tokens are rem and the offset is a `calc` over two of them, so reading
 * the custom property gives a STRING — `4rem` parses to the number 4, which is
 * a sixteenth of the distance and lands a reader behind the bar they were meant
 * to clear. Laying it out and measuring it is the only reading that is right
 * for every unit the token might be written in.
 */
function lengthOf(value: string): number {
  const probe = document.createElement('div')
  probe.style.cssText = `position:absolute;visibility:hidden;height:${value}`
  document.body.append(probe)
  const px = probe.getBoundingClientRect().height
  probe.remove()
  return px
}

/**
 * What is fixed over the top of the window, as a distance.
 *
 * Read from the token every sticky thing in the app already offsets from, and
 * measured at call time because the bar grows a band on a narrow screen. A
 * number written here instead would be a second copy of the bar's height, and
 * the copy is wrong the first time the bar changes.
 *
 * It sits beside the components rather than with any one surface's scrolling,
 * because what clears the bar is a fact about the SHELL: a contents rail and a
 * book's own glide are both offsetting from the same bar, and two readings of
 * it disagree the first time the bar changes.
 */
export function barClearance(): number {
  return lengthOf('calc(var(--topbar-h) + var(--s-4))')
}
